import {
  GET_ASSET_HIERARCHY_DOWNLOAD_TEMPLATE_REQUEST,
  GET_ASSET_HIERARCHY_DOWNLOAD_TEMPLATE_SUCCESS,
  GET_ASSET_HIERARCHY_DOWNLOAD_TEMPLATE_FAILURE,
  GET_ASSET_HIERARCHY_LIST_REQUEST,
  GET_ASSET_HIERARCHY_LIST_SUCCESS,
  GET_ASSET_HIERARCHY_LIST_FAILURE,
  DELETE_ASSET_HIERARCHY_LIST_REQUEST,
  DELETE_ASSET_HIERARCHY_LIST_SUCCESS,
  DELETE_ASSET_HIERARCHY_LIST_FAILURE,
  UPLOAD_ASSET_HIERARCHY_DATA_REQUEST,
  UPLOAD_ASSET_HIERARCHY_DATA_SUCCESS,
  UPLOAD_ASSET_HIERARCHY_DATA_FAILURE,
} from "actions/assets/assetHierarchy";
import { uSimError } from "utils/override";

import { convertAndDownload } from "utils/csv";

const initialState = {
  loading: false,
  list: [],
  templateLoading: false,
  template: [],
  validationMessage: "",
  uploading: false,
};

export default function assetHierarchy(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ASSET_HIERARCHY_DOWNLOAD_TEMPLATE_REQUEST: {
      return {
        ...state,
        templateLoading: true,
        template: [],
      };
    }

    case GET_ASSET_HIERARCHY_DOWNLOAD_TEMPLATE_SUCCESS: {
      convertAndDownload(payload, "assetHierarchy");
      return {
        ...state,
        templateLoading: false,
        template: payload,
      };
    }

    case GET_ASSET_HIERARCHY_DOWNLOAD_TEMPLATE_FAILURE: {
      uSimError(payload?.message || "Something went wrong");
      return {
        ...state,
        templateLoading: false,
        template: [],
      };
    }

    case GET_ASSET_HIERARCHY_LIST_REQUEST:
    case DELETE_ASSET_HIERARCHY_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case UPLOAD_ASSET_HIERARCHY_DATA_REQUEST: {
      return {
        ...state,
        uploading: true,
      };
    }

    case GET_ASSET_HIERARCHY_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: payload.map((it, i) => {
          return {
            ...it,
            id: i,
          };
        }),
      };
    }

    case DELETE_ASSET_HIERARCHY_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }

    case UPLOAD_ASSET_HIERARCHY_DATA_SUCCESS: {
      return {
        ...state,
        uploading: false,
      };
    }

    case GET_ASSET_HIERARCHY_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
        list: [],
      };
    }

    case DELETE_ASSET_HIERARCHY_LIST_FAILURE: {
      uSimError(payload?.message || "Something went wrong");
      return {
        ...state,
        loading: false,
      };
    }

    case UPLOAD_ASSET_HIERARCHY_DATA_FAILURE: {
      uSimError(payload?.message || "Something went wrong");
      return {
        ...state,
        uploading: false,
      };
    }

    default:
      return state;
  }
}
